import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row type ───

export interface EncounterVisualChartRow {
  id: string;
  org_id: string;
  clinic_id: string | null;
  patient_id: string;
  encounter_id: string;
  visit_id: string | null;
  chart_type: string;
  before_file_id: string | null;
  after_file_id: string | null;
  // Polymorphic compare refs (PRD.235). Default 'photo' on existing rows.
  before_source: string | null;
  after_source: string | null;
  before_chart_id: string | null;
  after_chart_id: string | null;
  base_type: string | null;
  base_image_id: string | null;
  template_id: string | null;
  drawing_data: string | null;
  label: string | null;
  sort_order: number | null;
  created_by_user_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

// ─── Queries ───

/**
 * Visual charting records for an encounter (PRD.165).
 * Newest first so the latest pair is [0].
 */
export function qEncounterVisualCharts(
  encounterId: string,
  chartType: string = 'before_after',
): QuerySpec<[string, string]> {
  return {
    key: ['encounter_visual_charts', 'by-encounter', encounterId, chartType] as const,
    sql: `SELECT * FROM encounter_visual_charts WHERE encounter_id = ? AND chart_type = ? ORDER BY created_at DESC`,
    params: [encounterId, chartType],
    watch: ['encounter_visual_charts'],
  };
}

/**
 * All visual charts (drawings + before/after) for a patient. Used by the
 * timeline preview so saved chartings surface per encounter without
 * needing one query per visit card.
 */
export function qPatientVisualCharts(patientId: string): QuerySpec<[string]> {
  return {
    key: ['encounter_visual_charts', 'by-patient', patientId] as const,
    sql: `SELECT * FROM encounter_visual_charts WHERE patient_id = ? ORDER BY encounter_id, created_at DESC`,
    params: [patientId],
    watch: ['encounter_visual_charts'],
  };
}
